export default {
  data: state => state.data,
  dataForEdit: state => {
    const {
      Nome,
      CidadeId,
      CidadeNome,
      EstadoId,
      EstadoNome,
      RegiaoId,
      RegiaoNome,
      DataInicio,
      DataFim,
      CadeiaId,
      CadeiaNome,
      IndicadorGrupoId,
      IndicadorGrupoDescricao,
      IndicadorFinalId,
      IndicadorNome,
      SafraId,
      SafraDescricao,
      CidadeDestinoId,
      CidadeDestinoNome,
      EstadoDestinoId,
      EstadoDestinoNome,
      RegiaoDestinoId,
      RegiaoDestinoNome
    } = state.data

    const Cadeia = {
      Id: CadeiaId,
      Nome: CadeiaNome
    }

    const Grupo = {
      Id: IndicadorGrupoId,
      Descricao: IndicadorGrupoDescricao
    }

    const Indicador = {
      Id: IndicadorFinalId,
      IndicadorNome: IndicadorNome,
      TemSafra: !!SafraId,
      TemRota: !!(EstadoDestinoId || RegiaoDestinoId || CidadeDestinoId)
    }

    const Safra = SafraId && {
      Id: SafraId,
      Descricao: SafraDescricao
    }

    const Cidade = CidadeId && {
      Id: CidadeId,
      Nome: CidadeNome
    }

    const Estado = EstadoId && {
      Id: EstadoId,
      Nome: EstadoNome
    }

    const Regiao = RegiaoId && {
      Id: RegiaoId,
      Nome: RegiaoNome
    }

    const CidadeDestino = CidadeDestinoId && {
      Id: CidadeDestinoId,
      Nome: CidadeDestinoNome
    }

    const EstadoDestino = EstadoDestinoId && {
      Id: EstadoDestinoId,
      Nome: EstadoDestinoNome
    }

    const RegiaoDestino = RegiaoDestinoId && {
      Id: RegiaoDestinoId,
      Nome: RegiaoDestinoNome
    }

    let Localidade
    if (EstadoId) Localidade = 'Estado'
    if (RegiaoId) Localidade = 'Regiao'
    if (CidadeId) Localidade = 'Cidade'

    let LocalidadeDestino
    if (EstadoDestinoId) LocalidadeDestino = 'Estado'
    if (RegiaoDestinoId) LocalidadeDestino = 'Regiao'
    if (CidadeDestinoId) LocalidadeDestino = 'Cidade'

    return {
      Nome,
      DataInicio,
      DataFim,
      Cadeia,
      Grupo,
      Indicador,
      Safra,
      Localidade,
      LocalidadeDestino,
      Cidade,
      Estado,
      Regiao,
      CidadeDestino,
      EstadoDestino,
      RegiaoDestino
    }
  }
}
